import { toolContainer } from '../screens/test/screen';

class Tool {
  static get sprite() {
    if ( !this._sprite ) {
      this.init();
    }
    return this._sprite;
  }

  static init() {
    throw new Error('Abstract static method not implemented in derived class');
  }

  static loadQuestion( question ) {
    toolContainer.removeChildren();
    toolContainer.addChild(this.sprite);
    if ( this.toggleSolutionBtn ) {
      this.toggleSolutionBtn.visible = false;
      this.toggleSolutionBtn.question = question;
    }
  }

  static onQuestionComplete( question ) {
    if ( this.toggleSolutionBtn ) {
      if ( !question.result ) {
        this.toggleSolutionBtn.visible = true;
        this.toggleSolutionBtn.showingCorrectSolution = false;
      }
    }
  }

  static showCorrectSolution( question ) {
    throw new Error('Abstract static method not implemented in derived class');
  }
  static showUserSolution( question ) {
    throw new Error('Abstract static method not implemented in derived class');
  }
}

export default Tool;
